export function countryCodeToFlagEmoji(countryCode: string): string | null {
	// Ensure the input is uppercase
	const code = countryCode.toUpperCase();

	// Validate the country code
	if (!/^[A-Z]{2}$/.test(code)) {
		return null;
	}

	// Convert the country code to flag emoji
	return [...code]
		.map((char) => String.fromCodePoint(char.charCodeAt(0) + 0x1f1a5))
		.join("");
}

export const getBaseUrl = () => {
	if (typeof window !== "undefined") {
		return window.location.origin;
	}
	if (process.env.NODE_ENV === "development") {
		return "https://localhost:3000";
	}
	if (process.env.VERCEL_ENV === "production") {
		return "https://itskaos.com";
	}

	if (process.env.VERCEL_ENV === "preview" && process.env.VERCEL_URL) {
		return `https://${process.env.VERCEL_URL}`;
	}

	return "https://itskaos.com";
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const getLqipProps = <
	T extends { style?: React.CSSProperties } & Record<string, any>,
>(
	lqip: string | number | undefined,
	props?: T,
) => {
	if (!lqip)
		return {
			...props,
		};

	return {
		...props,
		style: {
			...props?.style,
			"--lqip": lqip,
		} as React.CSSProperties,
		"data-lqip": lqip,
	};
};

export const formatProductPrice = (price?: string) => {
	if (!price) {
		return "";
	}

	return price.replace(/\.00(?=\s*\S+$)/, "");
};

const removeDecimalIfWhole = (price: string) => {
	return price.replace(/\.00(?=\s*\S+$)/, "");
};

export const priceFormatter = (
	price: number | string | undefined,
	currency: string | undefined,
) => {
	if (!price) return "";
	if (!currency) return "";

	if (typeof price === "number") {
		const fixedPrice = price.toFixed(2);

		return `${removeDecimalIfWhole(fixedPrice)} ${currency}`;
	}

	const priceWithoutCurrency = price.replace(
		new RegExp(`\\s*${currency}$`),
		"",
	);
	const numericPrice = parseFloat(priceWithoutCurrency);

	if (Number.isNaN(numericPrice)) {
		return price;
	}

	return `${removeDecimalIfWhole(numericPrice.toFixed(2))} ${currency}`;
};

export function humanizeString(str: string) {
	if (typeof str !== "string") return "";

	str = str.replace(/[-_]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");
	return str.replace(/\b\w/g, (char) => char.toUpperCase()).trim();
}
